import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, firstValueFrom, take } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LayerAPIService } from 'src/app/features/shared/services/API/LayersAPI.service';
import { PlaceLocationDetailsPopUpComponent } from '../../locations-section/components/3-panel-detail-locations/organisms/location-popup-details/place-location-detail-popup/place-location-details-popup.component';

@Injectable({
  providedIn: "root",
})
export class FrecuencyZonesLayerControlService {

  sourcePrefix = 'frecuency-zones-source';
  layerPrefix = 'frecuency-zones-layer';
  layerTextPrefix = 'frecuency-zones-text';

  isInitialized: boolean = false;

  popUp: any = null;
  hoveredMarker: any = null;
  hoveredMarkerFeature: any = null;

  constructor(
    private mapHelperService: MapHelperService,
    private http: HttpClient,
    private layerAPIService: LayerAPIService,
    private dialog: MatDialog,
    private toastrService: ToastrService
  ) {}


  async createAllSourcesAndLayer(): Promise<void> {
    // if (!this.mapHelperService._map || !this.mapHelperService.isMainSourceReady) {
    //   console.error('LayerControl: Mapa no está listo');
    //   return;
    // }

    if (!this.mapHelperService._map || !this.mapHelperService.isMainSourceReady || !this.mapHelperService.isStyleReady) {
        await firstValueFrom( this.mapHelperService.mainSource$.pipe(
            filter(state => state != null && state.isMainSourceReady && state.isStyleReady),
            take(1)
          )
        );
      }

    if (this.isInitialized) {
      return;
    }

    this.createSourceAndLayersForLevel();

    this.isInitialized = true;
  }

  private createSourceAndLayersForLevel(): void {
    const existingSource = this.mapHelperService.GetSourceByName(this.sourcePrefix);
    
    if (!existingSource) {

      this.mapHelperService.AddSourceEmptyGeoJson(this.sourcePrefix, "Puntos de zonas de frecuencia", 'bussineLocation.png');
      this.mapHelperService.AddLayerLocationsGeneral(this.layerPrefix, this.sourcePrefix, 'icon', "Puntos de zonas de frecuencia");
      this.mapHelperService.AddLayerText(this.layerTextPrefix, this.sourcePrefix, 'Identifier', "Etiqueta de puntos de zonas de frecuencia", -3);
      
      this.mapHelperService.AddSourceEmptyGeoJson(this.sourcePrefix+ '-active', "Punto activo de zona de frecuencia", 'bussineLocationA.png');
      this.mapHelperService.AddLayerLocationsGeneral(this.layerPrefix + '-active', this.sourcePrefix + '-active', 'icon', "Punto activo de zona de frecuencia");

      this.addEvent();
      
      console.log(`LayerControl: Source y layers creados para frecuencia`);
    } else {
      console.log(`LayerControl: Source ya existe para frecuencia`);
    }
  }

  private addEvent(){

    const mouseClick = (e) => {
      if (e.features.length > 0) {
        const feature = e.features[0];
        const identifier = feature.properties ?  feature.properties.Identifier : '';
        const coords = feature.geometry.coordinates;

        if (this.popUp) {
          this.popUp.close();
          this.popUp = null;
        }
        const popupData = {
          identifier: identifier,
          parentCoordX: coords[0],
          parentCoordY: coords[1],
          activeSourceName: this.sourcePrefix + '-active',
        };
        this.popUp = this.dialog.open( PlaceLocationDetailsPopUpComponent,
                  {
                    maxWidth: "98vw",
                    maxHeight: "92vh",
                    autoFocus: false,
                    restoreFocus: false,
                    hasBackdrop: false,
                    disableClose: true,
                    data: popupData,
                  }
                );
      }

    };

    const layerMouseOver = (e) => {
      
        const marker = e.features[0].properties;

        this.hoveredMarker = marker;
        this.hoveredMarkerFeature = e.features[0];

        var activeIcon = this.hoveredMarker.activeIcon as string;
        var icon = this.hoveredMarker.icon as string;
       
        this.mapHelperService._map.setLayoutProperty(
          this.layerPrefix,
          "icon-image",
          [
            "case",
            ["==", ["get", "Identifier"], marker.Identifier],
            activeIcon,
            ["get", "icon"],
          ]
        );

        // cambia el color del nombre
        this.mapHelperService._map.setPaintProperty(this.layerTextPrefix, "text-color", [
          "case",
          ["==", ["get", "Identifier"], marker.Identifier],
          "#0F010F",
          "#530aa8",
        ]);
      };

      const layerMouseLeave = () => {
        if (this.hoveredMarker) {
          if(!environment.production) console.log("hoveredMarkerId", this.hoveredMarker);

          this.mapHelperService._map.setLayoutProperty(
            this.layerPrefix,
            "icon-image",
            ["get", "icon"]
          );
          this.mapHelperService._map.setPaintProperty(
            this.layerTextPrefix,
            "text-color",
            "#530aa8"
          );

          this.hoveredMarker = null;
        }
      };

    const rightClick = (e) => {
      e.preventDefault();
      if (e.features.length > 0) {
        const feature = e.features[0];
        const lat = feature.geometry ? feature.geometry.coordinates[1] : '';
        const lng = feature.geometry ? feature.geometry.coordinates[0] : '';
        const coords = lat + ", " + lng;
        
        if (coords) {
          navigator.clipboard.writeText(coords).then(() => {
            this.toastrService.info('Coordenadas copiadas al portapapeles');
          }).catch(err => {
            console.error('Error al copiar al portapapeles:', err);
          });
        }
      }
    };

    this.mapHelperService._map.on('click', this.layerPrefix, mouseClick);
    this.mapHelperService._map.on('mouseenter', this.layerPrefix, layerMouseOver);
    this.mapHelperService._map.on('mouseleave', this.layerPrefix, layerMouseLeave);
    this.mapHelperService._map.on('contextmenu', this.layerPrefix, rightClick);
  }

  loadGeoJson(geoJson: any): void {
    this.mapHelperService.UpdateLayerGeoJson(this.sourcePrefix, geoJson);
    this.mapHelperService.FitBounds(geoJson, 150);
  }

  clearGeoJson(): void {
    this.mapHelperService.UpdateLayerGeoJson(this.sourcePrefix, this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson(this.sourcePrefix + '-active', this.mapHelperService.Empty_GeoJson);
  }

  destroy(): void {
    this.clearGeoJson();
    this.hoveredMarker = null;
    this.hoveredMarkerFeature = null;
    if (this.popUp) {
      this.popUp.close();
    }
    this.popUp = null;
    this.isInitialized = false;
  }

  openPopUp(identifier: string, coords: number[]){
    if (this.popUp) {
      this.popUp.close();
      this.popUp = null;
    }
    const popupData = {
            identifier: identifier,
            parentCoordX: coords[0],
            parentCoordY: coords[1],
            activeSourceName: this.sourcePrefix + '-active',
          };
    this.popUp = this.dialog.open( PlaceLocationDetailsPopUpComponent,
      {
        maxWidth: "98vw",
        maxHeight: "92vh",
        autoFocus: false,
        restoreFocus: false,
        hasBackdrop: false,
        disableClose: true,
        data: popupData,
      }
    );
  }
}
